"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CellWithCurrentNewValue(data, valueLabels) {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "table-cell_with-current-new"
  }, data.currentValue === data.newValue ? data.currentValue : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("p", null, data.currentValue), /*#__PURE__*/_react.default.createElement("b", null, data.newValue)), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("p", null, valueLabels.current), /*#__PURE__*/_react.default.createElement("b", null, valueLabels.new))));
}

var _default = CellWithCurrentNewValue;
exports.default = _default;
CellWithCurrentNewValue.propTypes = {
  data: _propTypes.default.shape({
    newValue: _propTypes.default.string,
    currentValue: _propTypes.default.string
  }).isRequired,
  valueLabels: _propTypes.default.shape({
    current: _propTypes.default.string,
    new: _propTypes.default.string
  })
};
CellWithCurrentNewValue.defaultProps = {
  valueLabels: {
    current: 'current',
    new: 'new'
  }
};